import { VscSearch } from "react-icons/vsc";
import { FiPlus } from "react-icons/fi";
import { useState, useEffect } from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Select, { components } from "react-select";
import { debounce } from "lodash";
import axios from "axios";
import { connection } from "utils/apiConnection.ts";

export default function Search({
  fastOrderingInfo,
  setFastOrderingInfo,
  // searchItem,setSearchItem,fetchProductItems
}) {
  const [addModalOrder, setAddModalOrder] = useState({
    selectedItem: [],
  });
  const [searchItem, setSearchItem] = useState([]);
  const getProducts = (value) => {
    if (value != "") {
      let formData = new FormData();
      formData.append("keyword", value);
      // formData.append("count", 30);
      // formData.append("page", 1);
      // formData.append("is_popular", 1);

      axios
        .post("http://old-sabadib.tatdemo.ir/api/get_products", formData)
        .then(({ data }) => {
          console.log("data", data.data);
          setSearchItem(
            data.data.map((val, ind) => {
              return {
                label: val.info.title,
                value: ind,
                price: val.info.price,
                data: val,
              };
            })
          );
        });
    } else {
      setSearchItem([]);
    }
  };
  const handler = debounce((value, action) => {
    if (action.action === "input-change") {
      getProducts(value);
    }
  }, 1000);
  const Option = ({ data, label, value, price, ...props }) => {
    return (
      <div className="search-items row mt-3 justify-content-center p-1 mx-0 ">
        <div className="col-4 col-sm-4 col-md-4 col-lg-1 p-0">
          <div className="Circle-img">
            {data.data.info.supplier_cover_img != "" ? (
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                }}
                src={` http://sabadi.tatdemo.ir/${data.data.info?.supplier_cover_img}`}
              ></img>
            ) : (
              <img
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                }}
                src={` http://sabadi.tatdemo.ir/${data.data.info?.product_cover_img}`}
              ></img>
            )}
          </div>
        </div>
        <div className=" col-4 col-sm-4 col-md-4 col-lg-3 align-self-center ">
          {data.data.info?.title}
        </div>

        <div
          style={{ whiteSpace: "nowrap " }}
          className="col-4 col-sm-4 col-md-3 col-lg-3  align-self-center "
        >
          {data.data.supplier_info[0]?.title}
        </div>
        <div className=" col-4 col-sm-4 col-md-3 col-lg-2 align-self-center ">
          {data.data.info?.weight_from} گرم
        </div>
        <div className="col-4 col-sm-4 col-md-3 col-lg-2  align-self-center ">
          {addCommas(data.data.info?.price)} تومان
        </div>
        <div className="col-12 col-sm-3 col-md-3 col-lg-1 align-self-center text-align-center m-auto ">
          <button
            className="Circle-search-add "
            onClick={() => {
              setFastOrderingInfo((prev) => {
                console.log("before add", data);
                let temp = [...prev];
                temp[0].itemSelected.push({ ...data });
                return [...temp];
              });
            }}
          >
            <FiPlus></FiPlus>
          </button>
        </div>
        {/* <components.Option
          {...props}
          label={data.label}
          price={data.price}
        /> */}
      </div>
    );
  };

  useEffect(() => {
    getProducts("");
  }, []);

  console.log("serch:", searchItem);
  return (
    <div className="parent-search container p-0 ">
      <div className="container p-0">
        <div className="d-flex  justify-content-between mx-0 p-4 ">
          <div style={{ width: "90%", border: "none", alignSelf: "center" }}>
            <Select
              options={searchItem}
              onInputChange={handler}
              components={{ Option }}
              name="input-search"
              onFocus={() => {
                setSearchItem([]);
              }}
            />
          </div>
          <div className="d-flex txt-search2">
            <div className="Circle-search2">
              <VscSearch></VscSearch>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
